// action types
export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";

export const API_REQUEST_COPILOT = "API_REQUEST_COPILOT";


export const API_ERROR = "API_ERROR";
export const CANCEL_API_REQUEST = "CANCEL_API_REQUEST";

export const SET_DASHBOARD_LOADER = "SET_DASHBOARD_LOADER";
export const SET_NOTIFICATION_LOADER = "SET_NOTIFICATION_LOADER";
export const SET_LANGUAGE = "SET_LANGUAGE";

export const SET_COPILOT_DIALOG = "SET_COPILOT_DIALOG";

export const UPDATE_COPILOT = "UPDATE_COPILOT";

export const COPILIT_ACTIVE_ID = "COPILIT_ACTIVE_ID";



export const API_REQUEST_JOINEDCHATROOMS = "API_REQUEST_JOINEDCHATROOMS";
export const API_SUCCESS_JOINEDCHATROOMS = "API_SUCCESS_JOINEDCHATROOMS";


export const API_REQUEST_CHATHISTORY = "API_REQUEST_CHATHISTORY";
export const API_SUCCESS_CHATHISTORY = "API_SUCCESS_CHATHISTORY";


export const API_REQUEST_MACHINES = "API_REQUEST_MACHINES";
export const API_SUCCESS_MACHINES = "API_SUCCESS_MACHINES";

export const API_REQUEST_CREATE_MACHINE = "API_REQUEST_CREATE_MACHINE";
export const API_SUCCESS_CREATE_MACHINE = "API_SUCCESS_CREATE_MACHINE";


export const API_REQUEST_USERS = "API_REQUEST_USERS";
export const API_SUCCESS_USERS = "API_SUCCESS_USERS";


export const API_REQUEST_INTERNAL_ATTACHMENTS = "API_REQUEST_INTERNAL_ATTACHMENTS";
export const API_SUCCESS_INTERNAL_ATTACHMENTS = "API_SUCCESS_INTERNAL_ATTACHMENTS";


export const API_REQUEST_MANUFACTURER_ATTACHMENTS = "API_REQUEST_MANUFACTURER_ATTACHMENTS";
export const API_SUCCESS_MANUFACTURER_ATTACHMENTS = "API_SUCCESS_MANUFACTURER_ATTACHMENTS";

export const API_REQUEST_CREATE_INTERNAL_ATTACHMENTS = "API_REQUEST_CREATE_INTERNAL_ATTACHMENTS";
export const API_SUCCESS_CREATE_INTERNAL_ATTACHMENTS = "API_SUCCESS_CREATE_INTERNAL_ATTACHMENTS";


export const API_REQUEST_CREATE_MANUFACTURER_ATTACHMENTS = "API_REQUEST_CREATE_MANUFACTURER_ATTACHMENTS";
export const API_SUCCESS_CREATE_MANUFACTURER_ATTACHMENTS = "API_SUCCESS_CREATE_MANUFACTURER_ATTACHMENTS";

export const INTER_SET_SAEDATA="INTER_SET_SAEDATA"

export const API_HEADER_SEARCH_REQUEST = "API_HEADER_SEARCH_REQUEST"
export const API_SUCCESS_HEADER_SEARCH_REQUEST = "API_SUCCESS_HEADER_SEARCH_REQUEST"

// action creators
export const apiRequest = ({ url, method,data,op }) => {
  return {
    type: API_REQUEST,
    meta: { url, method,data,op }
  };
};

export const apiRequestCopilot = ({ url, method,data }) => {
  return {
    type: API_REQUEST_COPILOT,
    meta: { url, method,data }
  };
};

export const apiRequestJOINEDCHATROOMS = ({ url, method,data }) => {
  return {
    type: API_REQUEST_JOINEDCHATROOMS,
    meta: { url, method,data }
  };
};

export const apiRequestCHATHISTORY = ({ url, method,data }) => {
  return {
    type: API_REQUEST_CHATHISTORY,
    meta: { url, method,data }
  };
};

export const apiRequestMACHINES = ({ url, method,data }) => {
  return {
    type: API_REQUEST_MACHINES,
    meta: { url, method,data }
  };
};
export const apiRequestCREATEMACHINE = ({ url, method,data }) => {
  return {
    type: API_REQUEST_CREATE_MACHINE,
    meta: { url, method,data }
  };
};

export const apiRequestUSERS = ({ url, method,data }) => {
  return {
    type: API_REQUEST_USERS,
    meta: { url, method,data }
  };
};

export const apiRequestINTERNALATTACHMENTS = ({ url, method,data }) => {
  return {
    type: API_REQUEST_INTERNAL_ATTACHMENTS,
    meta: { url, method,data }
  };
};
export const apiRequestCREATEINTERNALATTACHMENTS = ({ url, method,data }) => {
  return {
    type: API_REQUEST_CREATE_INTERNAL_ATTACHMENTS,
    meta: { url, method,data }
  };
};
export const apiRequestAddManuAttachment = ({ url, method,data }) => {
  return {
    type: API_REQUEST_CREATE_MANUFACTURER_ATTACHMENTS,
    meta: { url, method,data }
  };
};
export const apiRequestMANUFACTURERATTACHMENTS = ({ url, method,data }) => {
  return {
    type: API_REQUEST_MANUFACTURER_ATTACHMENTS,
    meta: { url, method,data }
  };
};

export const cancelApiRequest = () => {
  return {
    type: CANCEL_API_REQUEST
  };
};

export const apiSuccess = ({ response,op }) => ({
  type: API_SUCCESS,
  payload: response,
  optype:op
});



export const apiSuccessJOINEDCHATROOMS = ({ response }) => ({
  type: API_SUCCESS_JOINEDCHATROOMS,
  payload: response
});

export const apiSuccessCHATHISTORY = ({ response }) => ({
  type: API_SUCCESS_CHATHISTORY,
  payload: response
});
export const apiSuccessMACHINES = ({ response }) => ({
  type: API_SUCCESS_MACHINES,
  payload: response
});
export const apiSuccessCREATEMACHINE = ({ response }) => ({
  type: API_SUCCESS_CREATE_MACHINE,
  payload: response
});

export const apiSuccessUSERS = ({ response }) => ({
  type: API_SUCCESS_USERS,
  payload: response
});

export const apiSuccessINTERNALATTACHMENTS = ({ response }) => ({
  type: API_SUCCESS_INTERNAL_ATTACHMENTS,
  payload: response
});
export const apiSuccessMANUFACTURERATTACHMENTS = ({ response }) => ({
  type: API_SUCCESS_MANUFACTURER_ATTACHMENTS,
  payload: response
});
export const apiSuccessCREATEINTERNALATTACHMENTS = ({ response }) => ({
  type: API_SUCCESS_CREATE_INTERNAL_ATTACHMENTS,
  payload: response
});
export const apiSuccessCREATEMANUFACTURERATTACHMENTS = ({ response }) => ({
  type: API_SUCCESS_CREATE_MANUFACTURER_ATTACHMENTS,
  payload: response
});
export const apiError = ({ error }) => ({
  type: API_ERROR,
  payload: error
});

export const apiSearchHeaderRequest = ({ url, method,data}) => ({
  type: API_HEADER_SEARCH_REQUEST,
  meta: { url, method,data }
});

export const apiSuccessSearchHeaderRequest = ({ response }) => ({
  type: API_SUCCESS_HEADER_SEARCH_REQUEST,
  payload: response
});

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});
